import { render, staticRenderFns } from "./Deactivate.vue?vue&type=template&id=35386ac6&scoped=true"
import script from "./Deactivate.vue?vue&type=script&lang=js"
export * from "./Deactivate.vue?vue&type=script&lang=js"
import style0 from "./Deactivate.vue?vue&type=style&index=0&id=35386ac6&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35386ac6",
  null
  
)

export default component.exports